import { render } from "./AuthorizationView.vue?vue&type=template&id=749161e5&ts=true"
import script from "./AuthorizationView.vue?vue&type=script&lang=ts"
export * from "./AuthorizationView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__